import { cond, equals, always } from 'ramda'

export default (day = 0): string =>
  cond([
    [equals(0), always('Sunday')],
    [equals(1), always('Monday')],
    [equals(2), always('Tuesday')],
    [equals(3), always('Wednesday')],
    [equals(4), always('Thursday')],
    [equals(5), always('Friday')],
    [equals(6), always('Saturday')],
  ])(day as never)
